import { Spinner } from '@chakra-ui/react';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const PdfPreviewDocument = lazy(() =>
  import('./PdfPreviewDocument').then((module) => ({
    default: module.PdfPreviewDocument,
  })),
);

export interface PdfPreviewProps {
  identifier: string;
  title: string;
}

export function PdfPreview(props: PdfPreviewProps) {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<Spinner size="sm" label={t('general.loading')} />}>
      <PdfPreviewDocument key={props.identifier} {...props} />
    </Suspense>
  );
}
